import settings from 'src/config/settings'

const BP_REGISTRATION_FORM_PATH = '/page/bp-registration-form'

export const buildBPRegistrationFormUrl = (requestUid?: string) => {
  const path = requestUid
    ? `${BP_REGISTRATION_FORM_PATH}/uid/${requestUid}`
    : BP_REGISTRATION_FORM_PATH

  return `${settings.bpFormServerUrl.replace(/\/$/, '')}${path}`
}
